import types from '../types';

export const initialState = [];

export default function vendorAuditReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_VENDOR_AUDIT:
            const vendorAudit = action.payload;
            if(action.payload !== null) {
                return vendorAudit;
            } else return state;
        default:
            return state;
    }
};
